import React, { useMemo } from "react";
import { Avatar, Tooltip } from "@mui/material";
import { Person } from "@mui/icons-material";
import isNil from "lodash/isNil";
import { getFirstLetterOfString } from "../../utils/strings/getFirstLetterOfString";

const UserAvatar = ({
  size = 36,
  children,
  label,
  tooltip,
  showTooltip = false,
  sx,
}) => {
  const initials = useMemo(() => {
    if (children) {
      return children;
    }
    if (typeof label !== "string") return null;

    const trimmed = label.trim();
    if (!trimmed) return null;

    const parts = trimmed.split(" ").filter(Boolean);

    const first = getFirstLetterOfString(parts[0]);
    const last =
      parts.length > 1 ? getFirstLetterOfString(parts[parts.length - 1]) : "";

    return `${first}${last}`;
  }, [children, label]);

  const styles = useMemo(() => {
    return {
      width: size,
      height: size,
      fontWeight: 500,
      fontSize: size * 0.4,
      ".MuiSvgIcon-root": {
        fontSize: size * 0.55,
      },
      ...sx,
    };
  }, [sx, size]);

  const content = (
    <Avatar className="user-avatar" sx={styles}>
      {isNil(initials) || initials === "" ? (
        <Person sx={{ fontSize: size * 0.45 }} />
      ) : (
        initials
      )}
    </Avatar>
  );

  if (showTooltip && (label || tooltip)) {
    return (
      <Tooltip title={tooltip || label} arrow>
        {content}
      </Tooltip>
    );
  }
  return content;
};

export default UserAvatar;
